import * as React from 'react';
import IForskningOgRapporterProps from './IForskningOgRapporterProps';
import Pagination from '../SharedComponents/Pagination/Pagination';
import ResultPane from './ResultPane/ResultPane';
import NoResultPane from '../SharedComponents/NoResultPane/NoResultPane';
import Filter from '../SharedComponents/Filter/Filter';
import SearchBox from '../SharedComponents/SearchBox/SearchBox';
import SearchNavigationTabs from '../SharedComponents/SearchNavigationTabs/SearchNavigationTabs';
import FiltersSelected from '../SharedComponents/FiltersSelected/FiltersSelected';
import './ForskningOgRapporter.scss'
import { addNonActiveFilters, getFilterNames } from '../../utils'
import { getResults } from './getResults';
import IRefiners from '../../Models/IRefiners';
import IResponse from '../../Models/IResponse';
import { DisplayFormat } from '../../Models/DisplayFormat';
import { SearchPageLayout } from '../../Models/SearchLayout';
import { Resultnumber } from '../SharedComponents/Resultnumber';
import { toggleToTopComponent } from '../SharedComponents/MoveToTop/MoveToTop';
import { SuggestionBox } from '../SharedComponents/SuggestionBox';
import { InformationMessageBox } from '../SharedComponents/InformationMessageBox';
import { getUrlParameter, setUrlParameter, removeAllFilterParams, getFilterParametersFromUrl, removeHashFromUrl } from '../../utils/urlParamHelper';
import { getNumberOfActiveFilters, emptyFilterCheckboxes, getFilterNamesWithCheckedItems } from '../../utils/refinerHelpers';
import { getInfoMsg } from '../../utils/searchHelpers';
import { getCurrentDisplayFormat } from '../../utils/generalHelpers';
import { LogWarning } from '../../utils/logging';
import IForskningOgRapporterState from './IForskningOgRapporterState';
import { IFoRResult } from '../../Models/IResult';
import SortBySuggestion from "../SharedComponents/Suggestion/SortBySuggestion";
import { Heading, Button, ListUnordered, ListItem } from '@udir-design/react/beta';
import { ChevronDownIcon, ChevronUpIcon } from '@udir-design/icons';
import '../../udirsok-searchbox-redesign.scss'

export default class ForskningOgRapporter extends React.Component<IForskningOgRapporterProps, IForskningOgRapporterState> {
    private resultPerPage = 10;
    private refinementFilters = ['rapportnivaa','rapportutgiver','publisertdato','datoendret','rapportaardate','rapportinnholdstype'];
    private refinementFiltersShowAllValuesUrlParamName = 'filtervalues';
    private queryParameter = "query";

    public constructor(props: IForskningOgRapporterProps) {
        super(props);
        // Removing hash (#) from URL if exists
        if(window.location.hash && window.location.hash !== ""){
            removeHashFromUrl(window.location.href);
        }
        //Set up initial querydata from parameters
        let queryParameter = getUrlParameter(this.queryParameter);
        if(getUrlParameter("k") !== undefined){
            this.queryParameter = "k"
            queryParameter = getUrlParameter(this.queryParameter);
        }
        const initialPageNumber = getUrlParameter('page');
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);
        this.state = {
            currentPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : 1,
            initialQuery: queryParameter,
            displayFormat: getCurrentDisplayFormat(),
            initialPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : undefined,
            initialFilters: filterParameters ? filterParameters : undefined,
            showSearchTips: false
        }
    }

    public componentDidMount() {
        window.addEventListener("resize", _ => this._onWindowResize());
        window.onpopstate = () => this.onStatePopped();
        window.addEventListener("pageshow", (event: PageTransitionEvent) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
        this.setupAndRunInitialQuery();
        getInfoMsg().then(result => {
            if(result){
                if(result.forskning){
                    this.setState({ informationMessage: result.forskning.title });
                }
                for (var i = 0; i < result.length; i++) {
                    if(result[i].hasOwnProperty("forskning")){
                        this.setState({ informationMessage: result[i].forskning.title });
                        break;
                    }
                }
            }
        });
    }

    public componentDidUpdate() {
        toggleToTopComponent(this.state.results && this.state.results.items.length > 0);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", _ => this._onWindowResize());
        this._onWindowResize();
    }

    public render() {
        const numberOfResults = this.findNumberOfResults();
        const numberOfPages = this.findNumberOfPages();
        const numberOfActiveFilters = getNumberOfActiveFilters(this.state.filter, this.refinementFilters);
        const isDesktop = this.state.displayFormat === DisplayFormat.Desktop;
        const searchLayout = SearchPageLayout.FilterLeftResultsRight;
        const searchboxClass = (isDesktop && searchLayout===0) ? "searchBoxBanner filterLeftAligned" : "searchBoxBanner";
        const searchboxClassWithToggle = `${searchboxClass} ${this.state.showSearchTips ? 'tips-open' : 'tips-closed'}`;
        const resultinformationClass = isDesktop ? "searchVerticals" : "searchVerticals";
        const filterClass = (isDesktop && searchLayout===0) ? "filters" : "filters";
        const searchresultsClass = (isDesktop && searchLayout===0) ? "uds-results" : "uds-results";
        const shouldDisplayFilters = (this.state.results && this.state.results.items && this.state.results.items.length > 0) ||
            (this.state.filter && getNumberOfActiveFilters(this.state.filter, this.refinementFilters) > 0);
        const showAutocomplete = true;
        return (
            <div id="main-content" className="searchContainer">
                <div className='searchBoxBannerOuter'>
                    <div className={`${searchboxClassWithToggle}`}>
                        <div className="searchBoxBannerContent">
                            <div className="searchBoxContent">
                                <div className="leftBarSearchBox">
                                    <div className="searchHeader">
                                        <Heading className='searchText' level={1} data-size={isDesktop ? 'lg' : 'md'}>
                                            Søk i forskning og statistikk
                                        </Heading>
                                    </div>
                                    <SearchBox
                                        initialQuery={this.state.initialQuery ? this.state.initialQuery : ""}
                                        onSearch={(query, searchAsYouType) => this.onSearch(query, searchAsYouType)}
                                        newQuery={this.state.newStateQuery}
                                        placeholderText="Søk etter tittel, forfatter, tema o.l."
                                        autocomplete={showAutocomplete}
                                        searchVertical="Forskning" />

                                </div>
                                <div className="rightBarSearchBox">
                                    {/*
                                    <Button
                                        data-size="md"
                                        variant='tertiary'
                                        color='neutral'
                                        className="SearchTipsButton"
                                        onClick={() => this.setState({ showSearchTips: !this.state.showSearchTips })}
                                        aria-expanded={!!this.state.showSearchTips}
                                        aria-controls="SearchTipsContent"
                                    >
                                        Søketips
                                        {this.state.showSearchTips ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </Button>
                                    {this.state.showSearchTips && (
                                        <div className="SearchTipsContent" id="SearchTipsContent">
                                            <div className='SearchTipsContentText'>
                                                <ListUnordered>
                                                    <ListItem>
                                                        Søketreffet sorteres etter relevans. Relevans styres av hvor sentral søketermen du bruker er i tekstene i søketreffet, i kombinasjon med dato for publisering (jo nyere teksten er, jo mer relevant). Dersom du ønsker sortering kun etter publiseringsdato, kan du endre dette i nedtrekksmenyen til høyre for «Sorter på» nedenfor.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan angi flere ord innenfor anførselsestegn («…») for å søke etter disse ordene i den bestemte, angitte rekkefølgen. For eksempel søk på «Læring i barnehagen» for å finne søketreff med ordene i nøyaktig den rekkefølgen.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan bruke - for å ekskludere ord. For eksempel søke på: <em>rapporter -årsrapporter</em> for å finne alle treff med rapporter som ikke har med ordet årsrapporter
                                                    </ListItem>
                                                </ListUnordered>
                                            </div>
                                        </div>
                                    )}
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={`${resultinformationClass}`}>

                    <SearchNavigationTabs currentTab="forskning" searchQuery={this.state.searchboxQuery} />
                    {!isDesktop && shouldDisplayFilters && this.state.filter && (
                        <Filter
                            getFilterDisplayName={(filterName) => this.getFilterDisplayName(filterName)}
                            refiners={this.state.filter}
                            onFilterSelected={this.onFilterChanged.bind(this)}
                            onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                            displayFormat={this.state.displayFormat}
                            initialOpenFilterNames={['rapportinnholdstype', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                        />
                    )}
                    {!isDesktop && this.state.filter && numberOfActiveFilters > 0 && <FiltersSelected filters={this.state.filter} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} />}
                </div>
                <div className="resultContainer">
                    
                    <div className='filters-and-results'>
                        {isDesktop && (
                            <div className={`${filterClass}`}>
                                {/* 
                                {numberOfActiveFilters > 0 && shouldDisplayFilters && <span className="emptyFilterLink"><button onClick={() => this.emptyFilters()}>{`Tøm filtre (${numberOfActiveFilters})`}</button></span>}
                                */}
                                {shouldDisplayFilters && this.state.filter && (
                                    <Filter
                                        getFilterDisplayName={(filterName) => this.getFilterDisplayName(filterName)}
                                        refiners={this.state.filter}
                                        onFilterSelected={this.onFilterChanged.bind(this)}
                                        onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                                        displayFormat={this.state.displayFormat}
                                        initialOpenFilterNames={['rapportinnholdstype', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                                        filterChips={numberOfActiveFilters > 0 ? <FiltersSelected filters={this.state.filter!} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} /> : undefined}
                                    />
                                )}
                            </div>
                        )}
                        <div className={`${searchresultsClass}`}>
                            <InformationMessageBox
                                isDesktop={isDesktop}
                                currentPage="Forskning"
                                informationMessage={this.state.informationMessage}
                            />
                            <SuggestionBox
                                query = {this.state.query}
                                searchboxQuery = {this.state.searchboxQuery}
                                erronousQuery = {this.state.erronousQuery}
                                querySuggestion = {this.state.querySuggestion}
                                emptyFilters = {() => this.emptyFilters()}
                                initialFilters = {this.state.initialFilters}
                                searchWithoutFiltersHasResults = {this.state.searchWithoutFiltersHasResults}
                                isSearchingWithDeactivatedFilters = {this.state.isSearchingWithDeactivatedFilters}
                                results = {this.state.results}
                            />
                            {numberOfResults > 0 && (
                            <div className="numresults-sortby">
                                <Resultnumber currentPageNumber={this.state.currentPageNumber} isDesktop={isDesktop} numberOfResults={numberOfResults} resultPerPage={this.resultPerPage} searchQuery={this.state.query} />
                                {/*numberOfResults > 0 && (
                                <div className="results-sortby-suggestion">
                                    <SortBySuggestion
                                        currentTab="forskning"
                                        searchQuery={this.state.query}
                                        onSortChange={this.onSortChanged}
                                    />
                                </div>
                            )*/}
                            </div>
                            )}
                            {this.renderResultPane()}
                            {numberOfPages > 1 && <Pagination currentPage={this.state.currentPageNumber} numberOfPages={numberOfPages} onPageChanged={(newPageNumber) => this.onPageChanged(newPageNumber)} searchQuery={this.state.searchboxQuery} />}
                            {/*<MoveToTop />*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderResultPane() {
        if (!this.state.results) return null
        if (this.state.results.items.length === 0) {
            if (!this.state.query) return null;
            let currentFilters = getFilterParametersFromUrl(this.refinementFilters);
            return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={getFilterNames(currentFilters ? currentFilters : [])} />
        }
        return <ResultPane results={this.state.results.items as IFoRResult[]} queryText={this.state.results.queryText} />;
    }

    private getFilterDisplayName(filterName: string) {
        switch(filterName) {
            case 'rapportutgiver':
                return 'Utgiver';
            case 'publisertdato':
                return 'År';
            case 'datoendret':
                return 'År';
            case 'rapportaar':
                return 'År';
            case 'rapportaardate':
                return 'År';
            case 'rapportnivaa':
                return 'Nivå';
            case 'rapportinnholdstype':
                return 'Type innhold';
            default:
                return filterName
        }
    }

    private async setupAndRunInitialQuery() {
        let pageNumber = this.state.initialPageNumber ? this.state.initialPageNumber : 1;
        let initialFilters: any[] | undefined = undefined;
        let initialQuery: string = this.state.initialQuery ? this.state.initialQuery : '*';
        if(initialQuery !== '*') {
            setUrlParameter(document.location.href, this.queryParameter, initialQuery, true); //We do not set window.history on first load.
        }
        if (this.state.initialFilters && this.state.initialFilters.length > 0) {
            initialFilters = getFilterParametersFromUrl(this.refinementFilters);
            // Setting ative filters
        }
        this.setState({
            searchboxQuery: SearchBox.getSearchBoxQuery(),
            newStateQuery: undefined,
            currentPageNumber: pageNumber
        });

        // Checking if search should expand with all available filter values (used for predefined searches)
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if (filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all") {
            const allResults = await getResults(initialQuery, pageNumber, initialFilters);
            if (allResults && allResults.totalResults > 0) {
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                const remappedFilters = await this.buildFiltersDisjunctive(allResults, urlFilters, initialQuery, pageNumber);
                this.setState({
                    filter: remappedFilters,
                    results: allResults,
                    query: initialQuery,
                    isSearchingWithDeactivatedFilters: false,
                    searchWithoutFiltersHasResults: false,
                    querySuggestion: undefined
                });
            } else {
                // No results with filters — try without
                const resultsNoFilter = await getResults(initialQuery, pageNumber, addNonActiveFilters([]));
                if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: initialQuery,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: undefined,
                        initialFilters: undefined
                    });
                } else {
                    // No results at all — set state so the 0 results message is shown
                    this.setState({
                        results: allResults,
                        query: initialQuery,
                        searchWithoutFiltersHasResults: false,
                        querySuggestion: undefined
                    });
                }
            }
        } else {
            await this.runQuery(initialQuery, false, pageNumber, initialFilters, true);
        }
    }


    private onSearch(query: string, searchAsYouType: boolean) {
        let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
        let searchboxQuery = SearchBox.getSearchBoxQuery();

        // Remove filtervalues=all from URL when user searches
        if (getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all") {
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }

        this.setState({
            query: query,
            searchboxQuery: searchboxQuery
        });
        
        // When searching with active filters, we want to preserve all filter options
        const hasFilters = urlFilters && urlFilters.length > 0;
        
        if(hasFilters){
            this.runQuery(query, false, 1, urlFilters, false, true); // preserveFilters = true
        }else{
            this.runQuery(query, false, 1);
        }

        //Only update when user have initiated a search from a action, not type as you search
        if(searchAsYouType === true) {
            setUrlParameter(window.location.href, this.queryParameter, query, true);
        } else {
            setUrlParameter(window.location.href, this.queryParameter, query);
        }

    }

    private onSearchClearFilters(query: string) {
        //Clear all the url-params
        this.refinementFilters.forEach(refinementFilter => {
            setUrlParameter(window.location.href, refinementFilter, '');
        });
        this.onSearch(query, false);
    }

    private onPageChanged(newPageNumber: number) {
        let filter = this.state.filter ? this.state.filter : undefined;
        if (this.state.query) {
            this.runQuery(this.state.query, false, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            //Scroll to top
            window.scrollTo(0, 0);
        } else if (this.state.query === "" && this.state.results && this.state.results.totalResults > 10) {
            this.runQuery("*", false, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            window.scrollTo(0, 0);
        }
    }

    private remapFilters(fetchedRefiners: IRefiners[], initFilter: any[] | undefined, selectedFilter: string) {
        if (initFilter && initFilter.length > 0) {
            this.refinementFilters.forEach(filterName => {
                let currentInitFilter = initFilter.filter(val => val.Name === filterName)[0];

                if (currentInitFilter && fetchedRefiners) {
                    let currentFetchedFilter = fetchedRefiners.filter(val => val.Name === filterName)[0];
                    if (currentFetchedFilter) {
                        currentFetchedFilter.Entries.forEach(refiner => {
                            const matched = currentInitFilter.Entries.some(val => 
                                val.RefinementToken === refiner.RefinementToken ||
                                val.RefinementName === refiner.RefinementName ||
                                val.RefinementValue === refiner.RefinementValue ||
                                decodeURIComponent(val.RefinementValue) === refiner.RefinementValue
                            );
                            refiner.checked = matched;
                        });
                    }
                }
            });
        }
        return fetchedRefiners;
    }

    private dateRefinerNames = ['publisertdato', 'datoendret', 'rapportaardate'];

    /**
     * Translate raw date refiner name from URL format to display format.
     * E.g. "From 2018-01-01T00:00:00.0000000Z up to 2019-01-01T00:00:00.0000000Z" → "2018"
     */
    private translateDateNameForDisplay(rawName: string): string {
        const dateRegex = /(\d{4})-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        const match = rawName.match(dateRegex);
        if (!match) return rawName;
        const year = match[1];
        if (rawName.indexOf('Before') !== -1) {
            return `Før ${year}`;
        }
        if (rawName.indexOf('later') !== -1) {
            return year;
        }
        return year;
    }

    /**
     * Update refiner counts with disjunctive-like faceting.
     * For refiners WITHOUT checked entries: use counts from filteredResults (correct cross-refiner AND logic).
     * For refiners WITH checked entries: make a separate API call excluding that refiner's filter,
     * so we get accurate counts for all values in that refiner (OR within same group).
     */
    private async buildFiltersDisjunctive(
        filteredResults: IResponse,
        filterParams: any[],
        queryString: string,
        pageNumber: number
    ): Promise<IRefiners[]> {
        if (!filteredResults.refiners) return [];

        // Determine which refiner names have checked entries
        const checkedRefinerNames = new Set<string>(
            filterParams ? filterParams.map(p => p.Name) : []
        );

        // Deep copy refiners from filtered results as starting point
        let filters: IRefiners[] = JSON.parse(JSON.stringify(filteredResults.refiners));

        // Set checked property from filterParams
        if (filterParams && filterParams.length > 0) {
            this.refinementFilters.forEach(filterName => {
                const urlFilter = filterParams.find(p => p.Name === filterName);
                const refiner = filters.find(r => r.Name === filterName);
                if (refiner) {
                    refiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                }
            });
        }

        // Ensure every URL-selected filter entry exists in `filters` (with checked=true)
        // even if it isn't present in filteredResults.refiners. Without this, when the
        // filtered query returns a small set whose refiners don't include all selected
        // values, those values would be silently dropped from filtersExcludingThisRefiner
        // — producing incorrect counts for OTHER refiners' disjunctive calls.
        if (filterParams && filterParams.length > 0) {
            filterParams.forEach(urlFilter => {
                let refiner = filters.find(r => r.Name === urlFilter.Name);
                if (!refiner) {
                    refiner = { Name: urlFilter.Name, Entries: [] };
                    filters.push(refiner);
                }
                urlFilter.Entries.forEach(urlEntry => {
                    const exists = refiner!.Entries.some(e =>
                        e.RefinementToken === urlEntry.RefinementToken ||
                        e.RefinementValue === urlEntry.RefinementValue ||
                        e.RefinementName === urlEntry.RefinementName
                    );
                    if (!exists) {
                        refiner!.Entries.push({
                            RefinementCount: '0',
                            RefinementName: this.dateRefinerNames.includes(urlFilter.Name)
                                ? this.translateDateNameForDisplay(urlEntry.RefinementName)
                                : urlEntry.RefinementName,
                            RefinementToken: urlEntry.RefinementToken,
                            RefinementValue: urlEntry.RefinementValue,
                            checked: true
                        });
                    }
                });
            });
        }

        // For each refiner with checked entries: make disjunctive API call and replace entries
        for (const refinerName of Array.from(checkedRefinerNames)) {
            // Build filters with all refiners EXCEPT this one checked
            const filtersExcludingThisRefiner = filters.map(r => ({
                ...r,
                Entries: r.Entries.map(e => ({
                    ...e,
                    checked: r.Name === refinerName ? false : e.checked
                }))
            }));

            const disjunctiveResults = await getResults(queryString, pageNumber, filtersExcludingThisRefiner);

            if (disjunctiveResults.refiners) {
                const disjunctiveRefiner = disjunctiveResults.refiners.find(r => r.Name === refinerName);
                if (disjunctiveRefiner) {
                    // Set checked on the disjunctive entries from URL params
                    const urlFilter = filterParams.find(p => p.Name === refinerName);
                    disjunctiveRefiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                    // Add checked entries that are missing from API results (0 count)
                    if (urlFilter) {
                        urlFilter.Entries.forEach(urlEntry => {
                            const exists = disjunctiveRefiner.Entries.some(e =>
                                e.RefinementToken === urlEntry.RefinementToken ||
                                e.RefinementValue === urlEntry.RefinementValue ||
                                e.RefinementName === urlEntry.RefinementName
                            );
                            if (!exists) {
                                disjunctiveRefiner.Entries.push({
                                    RefinementCount: '0',
                                    RefinementName: this.dateRefinerNames.includes(refinerName)
                                        ? this.translateDateNameForDisplay(urlEntry.RefinementName)
                                        : urlEntry.RefinementName,
                                    RefinementToken: urlEntry.RefinementToken,
                                    RefinementValue: urlEntry.RefinementValue,
                                    checked: true
                                });
                            }
                        });
                    }
                    // Replace the refiner in the filter list
                    const idx = filters.findIndex(r => r.Name === refinerName);
                    if (idx !== -1) {
                        filters[idx] = disjunctiveRefiner;
                    } else {
                        filters.push(disjunctiveRefiner);
                    }
                }
            }
        }

        // Apply parent/child visibility logic
        filters.forEach(refiner => {
            // Ensure all level 0 entries (parents) and entries without parent are visible
            refiner.Entries.forEach(entry => {
                if (entry.level === 0 || !entry.parent) {
                    entry.hidden = false;
                }
            });

            // Set fakeChecked on parents and unhide children when entries are checked
            const checkedEntries = refiner.Entries.filter(entry => entry.checked === true);
            if (checkedEntries.length > 0) {
                refiner.Entries.forEach(entry => {
                    const isParent = checkedEntries.some(checkedEntry =>
                        entry.RefinementName === checkedEntry.parent && checkedEntry.parent !== undefined
                    );
                    const hasSameParent = checkedEntries.some(checkedEntry =>
                        checkedEntry.parent === entry.parent
                    );
                    if (isParent) {
                        entry.fakeChecked = true;
                    }
                    if (hasSameParent && entry.parent !== undefined) {
                        entry.hidden = false;
                    }
                });
            }

            // Unhide children when parent is checked or fakeChecked
            refiner.Entries.forEach(entry => {
                if ((entry.checked || entry.fakeChecked) && entry.level === 0) {
                    refiner.Entries.forEach(child => {
                        if (child.parent === entry.RefinementName) {
                            child.hidden = false;
                        }
                    });
                }
            });
        });

        return filters;
    }

    private async runQuery(query: string, isRerun: boolean, pageNumber?: number, filter?: IRefiners[], isInitialQuery?: boolean, preserveFilters?: boolean) {
        if(!filter && !preserveFilters){
            filter = this.state.filter;
        }
        let _pageNumber = pageNumber !== undefined ? pageNumber : 1;
        let results = await getResults(query, _pageNumber, filter);
        let resultsNoFilter;

        if (results.items.length === 0) {
            //Run query without any filters
            resultsNoFilter = await getResults(query, _pageNumber, addNonActiveFilters([]));
        }

        if (results.spellingSuggestion !== undefined && results.spellingSuggestion !== query && results.spellingSuggestion.length > 0 && results.items.length === 0) {
            //Run again with querysuggestion
            this.setState({
                querySuggestion: results.spellingSuggestion,
                erronousQuery: query
            });
            this.runQuery(results.spellingSuggestion, true, pageNumber, filter);
            return;
        } else if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
            // Filters gave 0 results but query without filters has results.
            // Show 0 results with filters preserved so the user can adjust them.
            const urlFilterParams = getFilterParametersFromUrl(this.refinementFilters);
            const remapped = this.remapFilters(resultsNoFilter.refiners, urlFilterParams, '');

            // Add missing URL-selected filter entries that aren't in the refiners (count=0)
            if (urlFilterParams && urlFilterParams.length > 0) {
                urlFilterParams.forEach(urlFilter => {
                    let refiner = remapped.find(r => r.Name === urlFilter.Name);
                    if (!refiner) {
                        refiner = { Name: urlFilter.Name, Entries: [] };
                        remapped.push(refiner);
                    }
                    urlFilter.Entries.forEach(urlEntry => {
                        const exists = refiner!.Entries.some(e =>
                            e.RefinementValue === urlEntry.RefinementValue ||
                            e.RefinementName === urlEntry.RefinementName ||
                            e.RefinementToken === urlEntry.RefinementToken
                        );
                        if (!exists) {
                            refiner!.Entries.push({
                                RefinementName: this.dateRefinerNames.includes(urlFilter.Name)
                                    ? this.translateDateNameForDisplay(urlEntry.RefinementName)
                                    : urlEntry.RefinementName,
                                RefinementValue: urlEntry.RefinementValue,
                                RefinementToken: urlEntry.RefinementToken,
                                RefinementCount: "0",
                                checked: true,
                                level: 0,
                                hidden: false
                            });
                        }
                    });
                });
            }

            // Apply parent/child visibility logic
            remapped.forEach(refiner => {
                refiner.Entries.forEach(entry => {
                    if (entry.level === 0 || !entry.parent) {
                        entry.hidden = false;
                    }
                });
                const checkedEntries = refiner.Entries.filter(entry => entry.checked === true);
                if (checkedEntries.length > 0) {
                    refiner.Entries.forEach(entry => {
                        const isParent = checkedEntries.some(ce =>
                            entry.RefinementName === ce.parent && ce.parent !== undefined
                        );
                        const hasSameParent = checkedEntries.some(ce =>
                            ce.parent === entry.parent
                        );
                        if (isParent) {
                            entry.fakeChecked = true;
                            entry.checked = false;
                        }
                        if (hasSameParent && entry.parent !== undefined) {
                            entry.hidden = false;
                        }
                    });
                }
                refiner.Entries.forEach(entry => {
                    if ((entry.checked || entry.fakeChecked) && entry.level === 0) {
                        refiner.Entries.forEach(child => {
                            if (child.parent === entry.RefinementName) {
                                child.hidden = false;
                            }
                        });
                    }
                });
            });

            this.setState({
                filter: remapped,
                results: results,
                query: query,
                isSearchingWithDeactivatedFilters: false,
                searchWithoutFiltersHasResults: false,
                querySuggestion: undefined
            });
        } else {
            //Found results, setting all the proper variables.
            let setStateObject: any = {
                results: results,
                searchWithoutFiltersHasResults: false,
                currentPageNumber: pageNumber ? pageNumber : 1
            };

            if (preserveFilters) {
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, query, _pageNumber);
            } else if (isInitialQuery) {
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, this.state.initialFilters || [], query, _pageNumber);
            } else {
                // Check if there are any checked filters in the current state
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;

                if (hasCheckedFilters) {
                    setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, query, _pageNumber);
                } else {
                    setStateObject['filter'] = this.remapFilters(results.refiners, currentFilterParams, "");
                }
            }

            setStateObject['isSearchingWithDeactivatedFilters'] = false;
            setStateObject['query'] = query;
            if (!isRerun) {
                setStateObject['querySuggestion'] = undefined;
            }
            setStateObject['currentPageNumber'] = _pageNumber;
            this.setState(setStateObject);
        }
    }


    private findNumberOfPages() {
        if (!this.state.results || !this.state.results.totalResults) {
            return 1;
        }
        return Math.ceil(this.findNumberOfResults() / this.resultPerPage);
    }

    private findNumberOfResults() {
        if (!this.state.results) {
            return 0;
        }
        return this.state.results.totalResults
    }



    private async onFilterChanged(refinerName: string, refinerIndex: number) {
        let stateFilter = this.state.filter;
        if (!stateFilter) {
            return;
        }

        // Clear filtervalues=all from URL when user interacts with filters
        if (getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all") {
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }

        // Deep copy to ensure React detects changes
        let currentFilter: IRefiners[] = JSON.parse(JSON.stringify(stateFilter));
        let currentFilterSelection = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries[refinerIndex];
        const newCheckedValue = !currentFilterSelection.checked;

        currentFilterSelection.checked = newCheckedValue;

        let currentFilterUrlParam = getUrlParameter(refinerName);
        let newFilterParamValue = `${currentFilterSelection.RefinementValue}`;
        let newFilterUrlParam = '';
        if (currentFilterSelection.checked) {
            if (currentFilterUrlParam) {
                newFilterUrlParam = `${currentFilterUrlParam};${newFilterParamValue}`;
            } else {
                newFilterUrlParam = newFilterParamValue;
            }
        } else {
            if (currentFilterUrlParam) {
                newFilterUrlParam = currentFilterUrlParam
                    .split(';')
                    .filter(val => val !== newFilterParamValue)
                    .join(';');
            }
        }
        setUrlParameter(window.location.href, refinerName, newFilterUrlParam);

        const queryString = this.state.query ? this.state.query : '';
        
        // Use URL filters as source of truth for the search query
        const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
        const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;

        // Search with URL-based filters (not state-based) to ensure all active filters are included
        const newResults = await getResults(queryString, 1, hasCheckedFilters ? currentFilterParams : undefined);

        // Fallback: if the filtered query gave 0 results but the query without filters has results,
        // build the filter panel from the unfiltered refiners so the filter panel remains visible
        // and the user can adjust their selection.
        if (newResults.items.length === 0 && hasCheckedFilters) {
            const resultsNoFilter = await getResults(queryString, 1, addNonActiveFilters([]));
            if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
                const remapped = this.remapFilters(resultsNoFilter.refiners, currentFilterParams, '');

                // Add missing URL-selected filter entries that aren't in the refiners (count=0)
                currentFilterParams.forEach(urlFilter => {
                    let refiner = remapped.find(r => r.Name === urlFilter.Name);
                    if (!refiner) {
                        refiner = { Name: urlFilter.Name, Entries: [] };
                        remapped.push(refiner);
                    }
                    urlFilter.Entries.forEach(urlEntry => {
                        const exists = refiner!.Entries.some(e =>
                            e.RefinementValue === urlEntry.RefinementValue ||
                            e.RefinementName === urlEntry.RefinementName ||
                            e.RefinementToken === urlEntry.RefinementToken
                        );
                        if (!exists) {
                            refiner!.Entries.push({
                                RefinementName: this.dateRefinerNames.includes(urlFilter.Name)
                                    ? this.translateDateNameForDisplay(urlEntry.RefinementName)
                                    : urlEntry.RefinementName,
                                RefinementValue: urlEntry.RefinementValue,
                                RefinementToken: urlEntry.RefinementToken,
                                RefinementCount: "0",
                                checked: true,
                                level: 0,
                                hidden: false
                            });
                        }
                    });
                });

                this.setState({
                    results: newResults,
                    filter: remapped,
                    currentPageNumber: 1,
                    query: queryString,
                    querySuggestion: undefined
                });
                return;
            }
        }

        let nextFilter;
        if (hasCheckedFilters) {
            nextFilter = await this.buildFiltersDisjunctive(newResults, currentFilterParams, queryString, 1);
        } else {
            // No filters checked - use results directly
            nextFilter = this.remapFilters(newResults.refiners, currentFilterParams, refinerName);
        }

        // buildFiltersDisjunctive already preserves the checked entry (adds it with
        // count=0 if missing from API results) and applies the correct checked state
        // from the URL params, so we can use nextFilter directly. Previously we called
        // ensureSelectedFilterValues here when checking, but that helper replaces the
        // freshly-computed disjunctive refiner with the stale refiner from the prior
        // state (overwriting the just-recomputed counts with old/wrong counts), which
        // caused e.g. 2019's count to remain (3) after toggle off→on instead of (4).
        let finalFilter = nextFilter;
        
        this.setState({
            results: newResults,
            filter: finalFilter,
            currentPageNumber: 1,
            query: queryString,
            querySuggestion: undefined
        });
    }

    private async emptyFilters() {
        let refiners = this.state.filter
        if (refiners === undefined) {
            return
        }

        emptyFilterCheckboxes('.filterContainer');

        const filterParams = [...this.refinementFilters, ...[this.refinementFiltersShowAllValuesUrlParamName]];
        removeAllFilterParams(window.location.href, filterParams);

        // Clear filter state and run query without filters
        this.setState({
            initialFilters: undefined
        });

        const query = this.state.query ? this.state.query : "*";

        // Pass empty array as filter to force fresh query without filters
        this.runQuery(query, false, 1, []);
    }

    private onRemoveFilter = (filterName: string, filterValue: string) => {
        // Remove filter value from URL
        const currentValue = getUrlParameter(filterName);
        if (currentValue) {
            const newValue = currentValue
                .split(';')
                .filter(v => decodeURIComponent(v) !== filterValue && v !== filterValue)
                .join(';');
            setUrlParameter(window.location.href, filterName, newValue);
        }

        // Run the query with updated filters from URL, preserving filter panel
        const queryString = this.state.query ? this.state.query : "*";
        const urlFiltersAfterRemoval = getFilterParametersFromUrl(this.refinementFilters);
        this.runQuery(queryString, false, 1, urlFiltersAfterRemoval, false, true);
    }

    private async onAllFilterClicked(refinerName: string) {
        let stateRefiners = this.state.filter;
        
        if (!stateRefiners) return;
        
        let allFilterClickedRefiner = stateRefiners.filter(refiner => refiner.Name === refinerName)[0];
        if (allFilterClickedRefiner !== undefined) {
            const somethingIsChecked = allFilterClickedRefiner.Entries.filter(entry => entry.checked === true).length > 0;
            if (somethingIsChecked) {
                allFilterClickedRefiner.Entries.forEach(refinerValue => {
                    refinerValue.checked = false;
                });
                setUrlParameter(window.location.href, refinerName, '');
                const query = this.state.query ? this.state.query : '';
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                this.runQuery(query, false, 1, urlFilters);
            }
        }
    }

    private onSortChanged = (sortValue: string) => {
        // Re-run query with current filters preserved
        this.runQuery(
            this.state.query ? this.state.query : '', 
            false, 
            1, // Reset to first page
            this.state.filter, // Keep current filters
            false, // isInitialQuery
            true // preserveFilters - keep all filter options visible
        );
    }

    private onStatePopped() {
        const newStateQuery = getUrlParameter(this.queryParameter);
        const initialPageNumber = getUrlParameter('page');
        const safeInitialPageNumber = initialPageNumber ? +initialPageNumber : 1;
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);

        //Set up variables properly (like in the constructor), and run the setupjob
        this.setState({
            newStateQuery: newStateQuery,
            initialQuery: newStateQuery,
            initialPageNumber: safeInitialPageNumber,
            initialFilters: filterParameters,
        }, () => {
            this.setupAndRunInitialQuery();
        });
    }

    private _onWindowResize() {
        let currentDisplayFormat = getCurrentDisplayFormat();
        this.setState({ displayFormat: currentDisplayFormat });
    }

}
